import Post from "../Post";
import getToken from "../token";

export default function addSignupGift(currency = "IR") {

  return Post("wallet/registerGift", {
    token: getToken(),
    currency: currency,
  });
}
